"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "mergeStyles", {
  enumerable: true,
  get: function get() {
    return _mergeStyles.default;
  }
});
exports.default = void 0;

var _mergeStyles = _interopRequireDefault(require("./mergeStyles"));

var _reactBaseStyles = _interopRequireDefault(require("./reactBaseStyles"));

var _default = _reactBaseStyles.default;
exports.default = _default;